<template>
  <div class="d-inline-block">
    <span v-if="toggleModel && ['ACTIVE', 'INACTIVE', 'SCHEDULED'].includes(status)" class="badge cursor-pointer unselectable" :class="colors[cleanStatus]" @dblclick="toggleStatus" title="Double-click to toggle the status">{{ cleanStatus }}</span>
    <span v-else class="badge unselectable" :class="colors[status]">{{ cleanStatus }}</span>
  </div>
</template>

<script>
export default {
  name: 'Badge',
  components: {},
  props: {
    value: {},
    toggleModel: {
      type: String,
      default: null
    },
    toggleModelHash: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    clientHash: {
      type: String,
      default: null
    },
    colors: {
      type: Object,
      default: function () {
        return {
          DRAFT: 'badge-dark',
          ACTIVE: 'badge-success',
          ARCHIVED: 'badge-dark',
          INACTIVE: 'badge-danger',
          NODATA: 'badge-danger',
          CONVERSION: 'badge-success',
          EVENT: 'badge-primary',
          GENERIC: 'badge-default',
          AUDIENCE: 'badge-dark',

          // Smart tooltips
          SCHEDULED: 'badge-yellow',
          ENDED: 'badge-dark',

          // Chargebee
          FUTURE: 'badge-success',
          IN_TRIAL: 'badge-success',
          NON_RENEWING: 'badge-danger',
          PAUSED: 'badge-danger',
          CANCELLED: 'badge-danger',

          // AI Agents
          PENDING: 'badge-yellow',
          RUNNING: 'badge-primary',
          COMPLETED: 'badge-success',
          ERROR: 'badge-danger',
        }
      }
    }
  },
  data () {
    return {
      status: this.value
    }
  },
  computed: {
    cleanStatus () {
      return (this.label ?? this.status).replaceAll('_', ' ')
    }
  },
  async mounted () {
    this.status = this.status ? this.status.toUpperCase() : this.status
  },
  methods: {
    async toggleStatus () {
      const newStatus = await this.$root.toggleStatus(this.toggleModel, this.toggleModelHash, this.status, this.clientHash)
      if (newStatus) {
        this.status = newStatus
      } else {
        console.log('BadgeComponent: no status returned, not changing the status', newStatus)
      }
      this.$emit('input', newStatus)
    }
  },
  watch: {
    // Ex.: reactivity based on table sorting and filters
    'value' () {
      this.status = this.value.toUpperCase()
    }
  }
}
</script>
